module.exports = "//static.hsappstatic.net/LoginUI/static-1.13356/img/donut_mobile.svg"